import { Dialog } from '@cimplico/components';
import { useDispatch } from 'react-redux';
import { removeInstance } from '../../store/slice';

type DeleteListItemConfirmationProps = {
    id: string;
    name: string;
    onClose: () => void;
};

function DeleteListItemConfirmation({ id, name, onClose }: DeleteListItemConfirmationProps): JSX.Element {
    const dispatch = useDispatch();

    return (
        <Dialog
            isOpen={true}
            description="Do you want to delete this list item with completed field values? Deleted item cannot be recovered."
            primaryAction="Delete"
            secondaryAction="Cancel"
            title={`Delete ${name}`}
            type="error"
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={(): void => {
                dispatch(removeInstance(id));
                onClose();
            }}
        />
    );
}
export default DeleteListItemConfirmation;
